import {
  Archive,
  Eye,
  MinusCircle,
  PlusCircle,
  RefreshDouble,
} from "iconoir-react";
import { PageAction } from "shared/components/organisms/PageActions";
import i18n, { i18nNamespace, loadLanguagePacks } from "i18n";

await loadLanguagePacks([i18nNamespace.Core, i18nNamespace.Widgets]);

export enum WidgetDetailsPageActionKey {
  PreviewWidget = "PREVIEW_WIDGET",
  AddToFavorites = "ADD_TO_FAVORITES",
  ArchiveWidget = "ARCHIVE_WIDGET",
}

export const WidgetDetailsViewSections: PageAction[] = [
  {
    Icon: Eye,
    key: WidgetDetailsPageActionKey.PreviewWidget,
    text: i18n.t("widgets:DETAILS.PAGE_ACTIONS.PREVIEW_WIDGET"),
  },
  {
    Icon: PlusCircle,
    key: WidgetDetailsPageActionKey.AddToFavorites,
    text: i18n.t("core:FAVORITES.CTA_BUTTON_COPY"),
    alternateInfo: {
      Icon: MinusCircle,
      text: i18n.t(`core:FAVORITES.CTA_BUTTON_COPY_ALTERNATE`),
    },
  },
  {
    Icon: Archive,
    key: WidgetDetailsPageActionKey.ArchiveWidget,
    text: i18n.t("core:ARCHIVE.CTA_BUTTON_COPY", {
      entityType: i18n.t("core:ARCHIVE.TYPE.WIDGET"),
    }),
    alternateInfo: {
      Icon: RefreshDouble,
      text: i18n.t("core:ARCHIVE.CTA_BUTTON_COPY_ALTERNATE", {
        entityType: i18n.t("core:ARCHIVE.TYPE.WIDGET"),
      }),
    },
  },
];
